import { File } from '../../pages/press/download';
import Article from "@components/CmsBlocks/Article";
export interface Article {
  id: number,
  attributes: {
    body: string,
    title: string,
    Date: string,
    Slug: string,
    createdAt: string,
    updatedAt: string,
    publishedAt: string,
    locale: string,
    Tag: string,
    image: {
      data: {
        attributes: File
      }
    }
  }
}

const BlogGallery = (data: any) => {

  const articles: Article[] = data.articles;
  return (
    <div className="relative my-4">

        { data.title && <h3>{data.title}</h3> }
        <div  className="container-rg"><div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 news-line-clamp">
        {
          articles && articles.map((article: Article, index: number) => {
            return <Article key={`article-index-${index}`} { ...article } />
          })
        }
        </div>
      </div>
    </div>
  )
}

BlogGallery.defaultProps = {};

export default BlogGallery;
